import PropTypes from "prop-types";
import { useField } from "formik";
import { ChoiceButton } from "./ChoiceButton";

export const FormikChoiceButton = ({
	name,
	type = "radio",
	value,
	label,
	id,
	disabled = false,
	className,
	validate,
	onChange: onChangeExternal,
}) => {
	const [field, meta, helpers] = useField({ name, validate });

	const selectedValues = Array.isArray(field.value) ? field.value : [];

	const handleChange = nextSelectedValues => {
		helpers.setValue(nextSelectedValues);
		if (!meta.touched) {
			helpers.setTouched(true);
		}

		if (onChangeExternal) {
			onChangeExternal(nextSelectedValues, { field, meta, helpers });
		}
	};

	return (
		<ChoiceButton
			type={type}
			name={field.name}
			id={id}
			value={value}
			label={label}
			selectedValues={selectedValues}
			disabled={disabled}
			className={className}
			onChange={handleChange}
		/>
	);
};

FormikChoiceButton.propTypes = {
	name: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["radio", "checkbox"]),
	value: PropTypes.string.isRequired,
	label: PropTypes.node.isRequired,
	id: PropTypes.string,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	validate: PropTypes.func,
	onChange: PropTypes.func,
};
